import DealerReceiveListPanel from "./dealerReceiveListPanel.container"

export default DealerReceiveListPanel
